import { DefaultThemeInternal } from "../../../internal/themes/DefaultTheme";
import { Theme8pxInternal } from "../../../internal/themes/Theme8px";
import { isFullTheme as _isFullTheme, markAs8pxTheme } from "../ThemeHelpers";
export var ThemeFactory = /*#__PURE__*/function () {
  function ThemeFactory() {}

  ThemeFactory.create = function create(theme, baseTheme) {
    var base = baseTheme || markAs8pxTheme(this.constructTheme(DefaultThemeInternal, Theme8pxInternal));
    return this.constructTheme(base, theme);
  };

  ThemeFactory.isFullTheme = function isFullTheme(theme) {
    return _isFullTheme(theme);
  };

  ThemeFactory.overrideDefaultTheme = function overrideDefaultTheme(theme) {
    Object.keys(theme).forEach(function (variableName) {
      var descriptor = Object.getOwnPropertyDescriptor(theme, variableName);
      Object.defineProperty(DefaultThemeInternal, variableName, descriptor);
    });
  };

  ThemeFactory.getKeys = function getKeys(theme) {
    var keys = [];

    while (theme != null) {
      Object.keys(theme).forEach(function (key) {
        if (!keys.includes(key)) {
          keys.push(key);
        }
      });
      theme = Object.getPrototypeOf(theme);
    }

    return keys.sort();
  };

  ThemeFactory.constructTheme = function constructTheme(base, theme) {
    var newTheme = Object.create(base);
    Object.keys(theme).forEach(function (propName) {
      var descriptor = Object.getOwnPropertyDescriptor(theme, propName);
      Object.defineProperty(newTheme, propName, descriptor);
    });
    return Object.freeze(newTheme);
  };

  return ThemeFactory;
}();